import React from "react";
import TypeCoachingCard from "../../components/card/typeCoachingCards/TypeCoachingCard";
import { MainContainer, CardContainer } from "../styles/sharedStyles"; // Import shared styles
import Title from "../../components/title/Title";
import TextParagraph from "../../components/text/TextParagraph";

const paragraph1 = `
    Bienvenue sur ton espace dédié à ta transformation physique et mentale ! ✨
    <br><br>
    Que tu cherches à mieux manger, te remettre en forme ou faire les deux, je suis là pour te guider, te motiver et t’aider à atteindre tes objectifs, pas à pas.
    <br><br>
    Découvre mes trois formules :
  `;

const CoachingTypesPresentationPage = () => {
  return (
    <MainContainer>
      <Title
        title="Coachings"
        summary="Choisissez l'offre qui vous correspond."
      />

      <TextParagraph content={paragraph1} />

      <CardContainer>
        <TypeCoachingCard
          title="💪 Coaching Musculation"
          description="Ton plan d'entraînement sur-mesure pour progresser efficacement en salle."
          linkTo="/coachingtypes/coachingmusculation"
        />
        <TypeCoachingCard
          title="🥗 Coaching Nutrition"
          description="Ton plan nutritionnel sur-mesure adaptés à ton style de vie, et à tes objectifs."
          linkTo="/coachingtypes/coachingnutrition"
        />
        <TypeCoachingCard
          title="⚡ Coaching Complet"
          description="Le combo parfait pour optimiser tes résultats grâce à l’alliance de la nutrition et de l’entraînement."
          linkTo="/coachingtypes/coachingmuscunutri"
        />
      </CardContainer>
    </MainContainer>
  );
};

export default CoachingTypesPresentationPage;
